import React from "react";
import { useLocale } from "@insightfulscience/smart-react/i18";
import Spinner from "@insightfulscience/atomic-react/Spinner";
import SmartForm from "@insightfulscience/smart-react/SmartForm";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import Button from "@insightfulscience/atomic-react/Button";
import Block from "@insightfulscience/atomic-react/Block";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import Html from "@insightfulscience/smart-react/Html";
import useFormAction from "@insightfulscience/smart-react/hooks/useFormAction";

import routes from "../routes";
import { submitEmail } from "./action";
import { initialState, validateForm } from "./form";

const FreeTrialForm = () => {
	const [t] = useLocale("free-trial");

	const [action, { isLoading, error, reset }] = useFormAction(submitEmail);

	return (
		<>
			<Row utility={{ justify: "center" }}>
				{isLoading && <Spinner />}
				<Col>
					<SmartForm textRender={t} {...{ initialState, validateForm, action }} onTouched={reset}>
						<Block sx={{ textAlign: "left" }}>
							<SmartForm.Field
								label="EMAIL"
								name="email"
								type="email"
								disabled={isLoading}
								error={error}
								fieldClassName="mb-6"
								required
								data-qa-selector="free-trial-email-input"
							/>
						</Block>
						<Row>
							<Col spacing={{ mt: 2, mb: 6 }}>
								<Block sx={{ textAlign: "center" }}>
									<Button
										type="submit"
										disabled={isLoading}
										isBlock
										data-qa-selector="free-trial-submit-button"
									>
										{t("SUBMIT")}
									</Button>
								</Block>
							</Col>
						</Row>
					</SmartForm>
				</Col>
			</Row>
			<Paragraph sx={{ fontSize: "xs", textAlign: "center" }}>
				<Html Tag="span">
					{t("AGREEMENT", {
						tosLink: routes.legal,
						ppLink: routes.privacyPolicy,
					})}
				</Html>
			</Paragraph>
		</>
	);
};

export default FreeTrialForm;
